import {MomentUtils} from "core/utils/MomentUtils";

/**
 * Componente para mostrar fechas formateadas en zona horaria de la organización
 */
const DateDisplay = ({
    date,
    format = "DD/MM/YYYY HH:mm:ss",
    emptyText = "-",
    className = "",
    title = false, // Si true, muestra tooltip con fecha completa
}) => {
    const {formatDate, timezone} = MomentUtils();

    if (!date) {
        return <span className={className}>{emptyText}</span>;
    }

    const formattedDate = formatDate(date, format);
    const fullDate = title ? formatDate(date, "dddd, DD [de] MMMM [de] YYYY [a las] HH:mm:ss") : null;

    return (
        <span className={className} title={title ? `${fullDate} (${timezone})` : undefined}>
            {formattedDate}
        </span>
    );
};

export default DateDisplay;
